import Icon from '../components/Icon.vue'

Icon.register({
  trash: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M432 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h120l9.4-18.7c3.9-7.9 11.9-13.3 21.3-13.3h0.1 114.3c0 0 0 0 0 0 9.4 0 17.6 5.4 21.5 13.3l9.4 18.7h120zM53.2 467l-21.2-339h384l-21.2 339c-1.6 25.1-22.4 45-47.9 45h-245.8c-25.5 0-46.3-19.9-47.9-45z'
      }
    ]
  }
})
